import { setupLayouts } from 'virtual:generated-layouts'
import { createRouter, createWebHistory } from 'vue-router'
import routes from '~pages'

// Login
//import { canNavigate } from '@layouts/plugins/casl'

function isTokenExpired(token) {
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const expirationTime = payload.exp * 1000; // Convert to milliseconds
    return Date.now() >= expirationTime; 
  } catch (error) {
    console.error('Error parsing token:', error);
    return true; // If there's an error parsing the token, consider it expired
  }
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL), //createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    ...setupLayouts(routes),
    /** 
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('~pages/not-authorized.vue'),
    },*/
  ],
})

const DYNAMIC_IMPORT_RELOAD_KEY = 'vite:dynamic-import-reload'

router.onError((error, to) => {
  const message = String(error?.message || '')
  const isDynamicImportError =
    message.includes('Failed to fetch dynamically imported module')
    || message.includes('Importing a module script failed')
    || message.includes('Loading chunk')

  if (!isDynamicImportError)
    return

  const hasReloaded = sessionStorage.getItem(DYNAMIC_IMPORT_RELOAD_KEY) === '1'

  if (hasReloaded) {
    sessionStorage.removeItem(DYNAMIC_IMPORT_RELOAD_KEY)
    return
  }

  sessionStorage.setItem(DYNAMIC_IMPORT_RELOAD_KEY, '1')
  window.location.assign(to?.fullPath || window.location.pathname)
})

router.afterEach(() => {
  if (sessionStorage.getItem(DYNAMIC_IMPORT_RELOAD_KEY) === '1')
    sessionStorage.removeItem(DYNAMIC_IMPORT_RELOAD_KEY)
})

// Role hierarchy for route-level access control (mirrors useModuleAccess.js)
const ROLE_LEVEL = { driver: 0, operator: 1, manager: 2, integrator: 3, owner: 4 }

// Navigation guard to check authentication
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token')
  const isAuthenticated = !!token && !isTokenExpired(token)
  console.log('Navigating from:', from.name, 'to:', to.name)

  if (!isAuthenticated) {
    console.log('Not authenticated — redirecting to auth-login (attempted:', to.name, ')')
    if (to.name === 'auth-login' || to.name === 'auth-register' || to.name === 'forgot-password' || to.name === 'auth-forgot' || to.name === 'auth-reset') {
      return next() // Allow access to auth routes
    }

    // Allow public routes (e.g. customer tracking magic link)
    if (to.meta?.public || to.path.startsWith('/track/')) {
      return next()
    }

    // Redirect to login if the route requires authentication
    localStorage.removeItem('token')
    next({ name: 'auth-login' })
  } else {
    // Role-based route guard: check meta.requiredRole
    const requiredRole = to.meta?.requiredRole
    if (requiredRole) {
      const userRole = localStorage.getItem('role') || 'operator'
      const userLevel = ROLE_LEVEL[userRole] ?? 0
      const requiredLevel = ROLE_LEVEL[requiredRole] ?? 0
      if (userLevel < requiredLevel) {
        return next({ path: '/not-authorized' })
      }
    }
    next() // Proceed to the route
  }

})

export default router
